<section class="pricing-lever-slider">
  <header class="pricing-lever-slider__header">
    <h3 class="pricing-lever-slider__title">
      {{ data?.title || 'Pricing lever' }}
      <span class="pricing-lever-slider__highlight" *ngIf="data?.highlightText">
        {{ data?.highlightText }}
      </span>
    </h3>

    <label class="pricing-lever-slider__input-wrap" *ngIf="configReady">
      <span class="pricing-lever-slider__input-label">{{ data?.inputLabel || 'Value' }}</span>
      <input
        class="pricing-lever-slider__input"
        type="number"
        [(ngModel)]="inputValue"
        [min]="min!"
        [max]="max!"
        [step]="step!"
        (change)="onInputChange()"
        (blur)="onInputChange()"
      />
      <span class="pricing-lever-slider__input-suffix">{{ suffix }}</span>
    </label>
  </header>

  <ng-container *ngIf="configReady; else missingConfig">
  <div class="pricing-lever-slider__track-row">
    <span class="pricing-lever-slider__range-label">{{ formattedMin }}</span>
    <mat-slider class="pricing-lever-slider__slider" [min]="min!" [max]="max!" [step]="step!">
      <input
        matSliderThumb
        [ngModel]="value"
        (ngModelChange)="onSliderInput($event)"
      />
    </mat-slider>
    <span class="pricing-lever-slider__range-label">{{ formattedMax }}</span>
  </div>

  <div class="pricing-lever-slider__value">{{ formattedValue }}</div>
  </ng-container>

  <ng-template #missingConfig>
    <div class="pricing-lever-slider__error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </ng-template>
</section>
